import { render } from "./ColorsLegend.vue?vue&type=template&id=0ddb1b36&scoped=true"
import script from "./ColorsLegend.vue?vue&type=script&lang=js"
export * from "./ColorsLegend.vue?vue&type=script&lang=js"

import "./ColorsLegend.vue?vue&type=style&index=0&id=0ddb1b36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddb1b36"]])

export default __exports__